import { IntlShape, useIntl } from 'react-intl'
import type { Variation, Verdict } from '../../views/ServicesStatistics/statisticsChange'
import './ChangeLine.scss'

/** «8 % más que 26/8–24/9», «Igual que el promedio del período»: la variación escrita, sin la flecha ni el veredicto. */
export function changeText(intl: IntlShape, variation: Variation, period: string): string {
  const messageId = variation.trend === 'up' ? 'ReportChangeMore'
    : variation.trend === 'down' ? 'ReportChangeLess' : 'ReportChangeSame'
  return intl.formatMessage({ id: messageId }, { value: variation.value, period })
}

interface ChangeLineProps {
  variation: Variation
  /** Contra qué se compara, ya escrito: «26/8–24/9», «el promedio del período (310)». */
  period: string
  /** «mejor» o «peor», solo en los indicadores donde subir o bajar tiene ese sentido (la espera). */
  verdict?: Verdict
}

/**
 * «▲ 8 % más que 26/8–24/9 (peor)»: la línea de variación de un indicador contra su referencia. La flecha es un adorno (la
 * dirección está en «más» o «menos») y el veredicto es una palabra, así que el dato no depende del color. Lo comparten los
 * reportes con indicadores (Estadísticas de atención, Atenciones de urgencia).
 */
export default function ChangeLine({ variation, period, verdict = null }: ChangeLineProps) {
  const intl = useIntl()
  return (
    <span className="nv-change">
      {variation.trend !== 'same' && (
        <span className="nv-change__arrow" aria-hidden="true">{variation.trend === 'up' ? '▲' : '▼'}</span>
      )}
      <span>{changeText(intl, variation, period)}</span>
      {verdict && (
        <span className="nv-change__verdict">
          {intl.formatMessage({ id: verdict === 'better' ? 'ReportChangeBetter' : 'ReportChangeWorse' })}
        </span>
      )}
    </span>
  )
}
